module.exports = __webpack_public_path__ + "img/kiss-wink-heart.92a9737c.svg";